import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {Card, Tabs} from "antd";
import DoneForYouPBN from "./done_for_you_pbn";

class Services extends React.Component {
    state = {
        pages: ['done-for-you-pbn'],
        titles: {
            'done-for-you-pbn': 'Done-for-you PBN',
        }
    };

    componentDidMount() {
        this.props.updatePage('Add-on Services');
    }

    changeTab(page) {
        if(this.state.pages.indexOf(page) > -1) {
            this.props.updatePage(this.state.titles[page]);

            if(page === 'done-for-you-pbn') {
                this.props.history.push('/services');
            } else {
                this.props.history.push('/services/' + page);
            }
        }
    }

    render() {
        let page = 'done-for-you-pbn';

        if(typeof this.props.match.params.page !== 'undefined' && this.state.pages.indexOf(this.props.match.params.page)) {
            page = this.props.match.params.page;
        }

        const items = [];

        items.push({ label: 'Done-for-you PBN', key: 'done-for-you-pbn', children: <DoneForYouPBN history={this.props.history} /> });


        return(
            <Card size='small'>
                <Tabs defaultActiveKey={page} onChange={(e) => this.changeTab(e)} items={items} />
            </Card>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user
});

export default connect(mapStateToProps, { updatePage })(Services);